function DiscordWidget() {
    return(
        <div className="discord-widget" >
            <iframe className="discord-frame" title="Discord Widget" src="https://discord.com/widget?id=705237582304247850&theme=dark" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
        </div>
    );
}

export {DiscordWidget};